module.exports = __webpack_public_path__ + "static/img/hezuo03.7227357.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo03.jpg
// module id = gLJy
// module chunks = 1